/**
 * ONE way to mint a refund's durable identity.
 *
 * Sep 2026 (third independent review of PR #185) — lifted out of
 * `RefundOrderModal` because a SECOND refund surface now exists: the
 * duplicate-collection control in the order details drawer, which
 * refunds a double charge by its own payment id (see
 * `DuplicateCollectionRefund`). Two surfaces minting refund identifiers
 * two ways is how one of them ends up with a guessable key.
 *
 * Cryptographically strong, and long enough that two operators acting at
 * the same moment cannot collide. `crypto.randomUUID` is available in
 * every browser this admin targets; the `getRandomValues` path is the
 * fallback for older Safari, and neither path uses `Math.random`, whose
 * output is guessable and, across two tabs seeded alike, repeatable.
 */
export const REFUND_INTENT_PREFIX = "ri-";

export function newRefundIntentId() {
  const c = (typeof globalThis !== "undefined" && globalThis.crypto) || null;
  if (c && typeof c.randomUUID === "function") {
    return REFUND_INTENT_PREFIX + c.randomUUID().replace(/-/g, "");
  }
  if (c && typeof c.getRandomValues === "function") {
    const bytes = c.getRandomValues(new Uint8Array(16));
    return (
      REFUND_INTENT_PREFIX +
      Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("")
    );
  }
  // No CSPRNG at all: refuse rather than mint a guessable key, which
  // could collide with another operator's in-flight refund.
  throw new Error("This browser cannot generate a secure refund reference.");
}
